define('presentation/common/subscriberSelection/validators/subscriberSelectionValidator',['presentation/common/validation/commonValidator',
    'presentation/common/validation/validationRule',
    'constants/validationMessageEnumerations',
    'common/specifications/validEmailAddressSpecification'], function() {
    return function() {
        const self = this;

        const ValidEmailAddressSpecificationConstructor = require('common/specifications/validEmailAddressSpecification');
        const ValidationRulesConstructor = require('presentation/common/validation/validationRule');
        const CommonValidatorConstructor = require('presentation/common/validation/commonValidator');

        const _validationMessageEnumerations = require('constants/validationMessageEnumerations');
        const _validEmailAddressSpecification = new ValidEmailAddressSpecificationConstructor();
        let _viewModel;
        let _commonValidator;


        self.registerViewModel = function(ViewModel) {
            var newUserValidationMessageBase = _validationMessageEnumerations.clientui.presentation.settings.userGroups.addUserGroup;
            var validationRules = new ValidationRulesConstructor();

            validationRules.field("displayValues")
                .addValidation(_isAtLeastOneSelectionRequired, newUserValidationMessageBase.membersRequired);

            validationRules.array("emailSubscribers")
                .arrayField("displayName")
                .addValidationI18n(_validEmailAddressSpecification.isSatisfiedBy, 'emailAddressInvalid')
                .addValidationI18n(_isEmailAddressUnique, 'accountProfile:emailAddressNotUnique');

            _commonValidator = new CommonValidatorConstructor(ViewModel, validationRules);
            _viewModel = ViewModel;
        };

        self.validate = function() {
            return _commonValidator.validate();
        };

        var _isAtLeastOneSelectionRequired = function(displayValues) {
            if(_viewModel.isAtLeastOneItemRequired && displayValues < 1) {
                return false;
            } else {
                return true;
            }
        };

        const _isEmailAddressUnique = (emailAddress) => {
            let emailAddressMatches = 0;
            _viewModel.emailSubscribers().forEach((emailSubscriber) => {
                if (emailSubscriber.displayName() === emailAddress) {
                    emailAddressMatches++;
                }
            });
            return emailAddressMatches < 2;
        };
    };
});

